import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePopularCityQuery } from "../api/queries/cityQueries";
import Utils from "../utils/utils";
import { CityCard } from "./box/CityCard";
import clsx from "clsx";
import { Tv2 } from "lucide-react";
import { useTranslationEx } from "../hooks/useTranslationEx";
interface PopularCitiesProps {}

const PopularCities: React.FC<PopularCitiesProps> = ({}) => {
  const [hoveredTab, setHoveredTab] = useState<number | null>(null);
  const [selectArea, setSelectArea] = useState<number | null>(null);
  const [selectCountry, setSelectCountry] = useState<number | null>(null);
  const { t } = useTranslation();
  const { t2 } = useTranslationEx();

  const { data: poplularCitiesRes } = usePopularCityQuery();
  const handleMouseEnter = (menuName: number | null) => {
    if (menuName !== hoveredTab) {
      setSelectArea(0);
      setHoveredTab(menuName);
      setSelectCountry(0);
    }
  };

  const handleMouseLeave = () => {
    setSelectArea(0);
    setHoveredTab(null);
    setSelectCountry(0);
  };

  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (menuRef.current) {
      Utils.adjustPosition(menuRef.current);
    }
  }, []);

  const renderMenuTab = (name: string, img: string) => {
    const menus = poplularCitiesRes?.regions;
    return (
      <ul>
        <li
          onClick={() => handleMouseEnter(null)}
          className={`min-h-[4rem] w-[15rem] content-center border-b border-[#EAEEF3] px-6 py-[0.625rem] ${
            hoveredTab === null
              ? "bg-primary hover:bg-primary"
              : "hover:bg-gray-100"
          }`}
        >
          <p className="text-[0.875rem] font-semibold leading-[1.375rem] text-[#232323]">
            {t("Popular destination")}
          </p>
        </li>
        {menus?.map((menu, indexMenu) => (
          <li
            key={indexMenu}
            onClick={() => {
              if (menu?.subregion?.length === 1) {
                handleMouseEnter(indexMenu);
              }
            }}
            className={`min-h-[4rem] w-[15rem] content-center border-b border-[#EAEEF3] py-[0.625rem] pl-6 pr-[1.0625rem] ${
              hoveredTab === indexMenu
                ? "bg-primary hover:bg-primary"
                : "hover:bg-gray-100"
            }`}
          >
            <p className="text-[0.875rem] font-semibold leading-[1.375rem] text-[#232323]">
              {t(menu.menuName || "")}
            </p>
            <div className="flex flex-wrap gap-x-3 gap-y-1.5">
              {menu?.subregion?.map((area, index) => (
                <button
                  key={area.areaName}
                  onClick={() => {
                    setHoveredTab(indexMenu);
                    setSelectArea(index);
                    setSelectCountry(0);
                  }}
                  className={` ${
                    selectArea === index && indexMenu === hoveredTab
                      ? "text-primary-light"
                      : "text-[#5E6D77]"
                  } text-[0.75rem] font-normal leading-[1.25rem]`}
                >
                  {t(area.areaName || "")}
                </button>
              ))}
            </div>
          </li>
        ))}
      </ul>
    );
  };
  const renderTabContent = () => {
    if (hoveredTab === null) {
      return (
        <div className="grid h-fit w-full grid-cols-4 gap-4 p-8">
          {poplularCitiesRes?.popularDestination.filter(Boolean).map((city) => (
            <CityCard
              key={city.id}
              {...city}
              cdnParams={{
                format: "webp",
                width: 150,
              }}
            />
          ))}
        </div>
      );
    }
    const menus = poplularCitiesRes?.regions;
    return (
      <div className="flex w-full">
        <div>
          <ul className="pt-6">
            {menus &&
              menus[hoveredTab]?.subregion?.[selectArea ?? 0]?.country?.map(
                (menu, index) => (
                  <li
                    key={index}
                    className={`content-center hover:bg-[#f3f4f6]`}
                  >
                    <button
                      onClick={() => {
                        setSelectCountry(index);
                      }}
                      className={clsx(
                        `min-h-[4rem] w-[9.0625rem] py-[0.625rem] pl-6 text-start text-[0.875rem] font-semibold leading-[1.375rem]`,
                        selectCountry === index
                          ? "text-primary-light"
                          : "text-[#232323]",
                      )}
                    >
                      {t2(menu.countryName)}
                    </button>
                  </li>
                ),
              )}
          </ul>
        </div>
        <div className="grid h-fit grid-cols-4 gap-4 p-6">
          {menus?.[hoveredTab]?.subregion?.[selectArea || 0]?.country?.[
            selectCountry || 0
          ]?.cities
            ?.filter(Boolean)
            .map((city) => (
              <CityCard
                key={city.id}
                {...city}
                cdnParams={{
                  format: "webp",
                  width: 150,
                }}
              />
            ))}
        </div>
      </div>
    );
  };
  return (
    <aside
      onMouseLeave={handleMouseLeave}
      ref={menuRef}
      className={clsx(
        "left-0 w-[53.5rem] space-y-8 overflow-hidden rounded-b-[0.9375rem] bg-white shadow-lg transition-opacity duration-300 group-hover:bottom-auto group-hover:top-[101%] group-hover:opacity-100",
        "absolute bottom-[18.75rem] opacity-0",
      )}
    >
      <div className="flex">
        {/* tabs */}
        <div className="border-r border-[#EAEEF3]">
          {renderMenuTab(t("Popular destination"), "")}
        </div>
        {/* content */}
        {renderTabContent()}
      </div>
    </aside>
  );
};

export default PopularCities;
